import dynamic from 'next/dynamic';
import { SummaryOfChargesProps } from './SummaryOfCharges.types';
import { SummaryOfChargesV2Props } from './V2/index.types';

export const SummaryOfCharges = dynamic<SummaryOfChargesProps>(() => import('./SummaryOfCharges'));

export const SummaryOfChargesV2 = dynamic<SummaryOfChargesV2Props>(() =>
  import('./V2').then(module => module.SummaryOfChargesV2)
);
